import { useTheme } from '@mui/material';

export const useSxStyles = () => {
  const theme = useTheme();

  return {
    fieldSet: {
      display: 'flex',
      flexDirection: 'column',
      gap: theme.spacing(1),
      margin: theme.spacing(1, 0),
    },
  };
};
